import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Autocomplete } from "@similarweb/ui-components";

export const StyledAutocomplete = styled(Autocomplete)<{ disabled?: boolean }>`
    z-index: 2;
    height: 40px;
    .AutoCompleteContainer {
        transform: none;
        padding: 0;
        ${({ disabled }) =>
            disabled &&
            css`
                border-color: ${colorsPalettes.carbon[100]};
                background-color: ${colorsPalettes.bluegrey[200]};
                & .input-container {
                    background-color: ${colorsPalettes.bluegrey[200]};
                }
            `}
    }

    .ListItemsContainer {
        padding-top: 6px;
        max-height: 200px;
        overflow-y: auto;
        &:before {
            position: absolute;
            top: 5px;
        }
    }

    & input {
        padding: 0;
    }

    & ${SWReactIcons}[data-automation-icon-name="plus"] {
        width: 24px;
        height: 24px;
        min-width: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        & svg {
            width: 14px;
            height: 14px;
            & path {
                fill: ${colorsPalettes.carbon[200]};
            }
        }
    }
`;

export const StyledNoSearchResultsFoundContainer = styled.div`
    text-align: center;
    box-sizing: border-box;
    padding-left: 5px;
    padding-right: 5px;
    overflow-wrap: anywhere;
`;
